import React, { useState } from 'react';
import BasicModal from "../v2/views/Onboarding/Utilities/BasicModal";
import { SnackBar } from "../common";
import {Box} from '@mui/material';
import ActionButton from '../v2/common/ActionButton';
import BasicTextField from "../v2/common/BasicTextField";
import BasicMultilineTextField from "../v2/common/BasicMultilineTextField";
import moduleStyles from "./Styles.module.css"

const minBioLength = 50;

export default function JoinOrganizationModal({ show, onHide, onSave, payload }) {
    const [formData, setFormData] = useState({
        nickname: payload.employmentNickname || '',
        bioTextarea: {
            value: payload.employmentBio || '',
            count: payload.employmentBio?.length || 0,
        }
    });

    const handleChange = (event) => {
        setFormData(prev => ({
            ...prev,
            [event.target.name]: event.target.value
        }));
    };

    const handleBioChange = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: {
                value: e.target.value,
                count: e.target.value.length
            }
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const bioText = formData.bioTextarea.value;
        const bioTextCount = formData.bioTextarea.count;

        if (bioTextCount >= minBioLength) {
            onSave({
                ...payload,
                bio: bioText,
                nickname: formData.nickname,
                id: payload.employmentId
            });
        } else if (!bioText || bioTextCount === 0) {
            SnackBar.showMessage("Please enter your bio");
        } else if (bioTextCount < minBioLength) {
            SnackBar.showMessage(`${bioTextCount} characters entered. Please enter a longer bio!`);
        }
    };

    const { organizationName, employmentId } = payload;
    const headerText = employmentId
        ? `Edit Bio for ${organizationName}`
        : `Join ${organizationName} and start practicing`;

    return (
        <BasicModal
            open={show}
            handleClose={onHide}
            title={headerText}
        >
            <form name="form" onSubmit={handleSubmit}>
                {!employmentId && (
                    <Box sx={styles.joinText}>
                        Your nickname will be displayed to the company and their customers.
                        Use the bio to share a few sentences about yourself and why you are
                        excited to work with the company.
                    </Box>
                )}

                <Box>
                    <Box mb={{xs: "10px", sm: "10px", md: "15px", lg: "15px"}}>
                        <Box sx={styles.inputDesc}>Nickname</Box>
                        <BasicTextField
                            type="text"
                            name="nickname"
                            value={formData.nickname}
                            handleChange={handleChange}
                        />
                    </Box>

                    <Box mb={{xs: "10px", sm: "10px", md: "15px", lg: "15px"}}>
                        <Box sx={styles.inputDesc}>
                            <span>Bio</span>
                            <span className={moduleStyles.bioCount}>
                            [{minBioLength} minimum characters. Count: {formData.bioTextarea.count}]
                        </span>
                        </Box>
                        <BasicMultilineTextField
                            name="bioTextarea"
                            input={{value: formData.bioTextarea.value}}
                            handleChange={handleBioChange}
                            meta={{}}
                        />
                    </Box>
                </Box>

                <Box sx={styles.actions}>
                    <ActionButton
                        label={"Cancel"}
                        type={"button"}
                        action={onHide}
                        buttonBordered={true}
                        sx={{width: '100px'}}
                    />
                    <ActionButton
                        label={employmentId ? "Save" : "Join"}
                        sx={{width: '100px'}}
                    />
                </Box>
            </form>


        </BasicModal>
    );
}

const styles = {
    joinText: {
        fontFamily: 'FustatMedium',
        lineHeight: "20px",
        color: '#4F4F4F',
        marginBottom: 2
    },
    inputDesc: {
        fontFamily: 'FustatMedium',
        fontSize: '14px',
        fontWeight: 600,
        color: '#495D5E',
        mb: '7px',
    },
    bioCount: {
        fontFamily: 'FustatMedium',
        fontWeight: 500,
        color: '#666',
        marginLeft: 3,
    },
    actions: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '18px',
        paddingTop: '20px'
    }
};